import { fetchQuery } from '../utils/data/graphql';
import { seoFragment } from './seo';

export const podcastByURIQuery = `query($uri: ID!) {
  podcast(id: $uri, idType: SLUG){
    id
    title
    content
    ${seoFragment}
    tags {
      nodes {
        slug
        name
      }
    }
    podcastVideo {
      youtubeUrl
    }
    articleImage {
      thumbnail {
        mediaItemUrl
      }
    }
    lowerPageContent {
      content
    }
    sponsorship {
      articleHasBeenSponsored
    }
    articleAuthor {
      author {
         ... on ArticleAuthor {
          title
          authorDetails {
            bio
            company
            companyWebsiteUrl
            image {
              sourceUrl
            }
            jobTitle
          }
        }
			}
			useSavedAuthor
      oneOffAuthor {
        image {
          mediaItemUrl
        }
        bio
        company
        companyWebsiteUrl
        fieldGroupName
        jobTitle
        name
      }
    }
  }
}`;

export const fetchPodcastByURI = async (uri: string) => {
  const res = await fetchQuery(podcastByURIQuery, {
    uri: uri
  });
  return res.data;
};
